"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var PasswordReset_1 = require("@components/case/login/passwordReset/PasswordReset");
/**
 * パスワード再設定表示
 *
 * @return {*}
 */
var Index = function () {
    return (0, jsx_runtime_1.jsx)(PasswordReset_1.PasswordReset, {});
};
// eslint-disable-next-line import/no-default-export -- 暫定対応
exports.default = Index;
